function normalizeSearchText(rawValue) {
  return String(rawValue || '')
    .trim()
    .toLocaleLowerCase('de')
    .replace(/\s+/g, ' ');
}

function expandGermanSearchCharacters(value) {
  return value
    .replace(/ä/g, 'ae')
    .replace(/ö/g, 'oe')
    .replace(/ü/g, 'ue')
    .replace(/ß/g, 'ss');
}

function stripDiacritics(value) {
  return value.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}

function buildSearchVariants(rawValue) {
  const normalized = normalizeSearchText(rawValue);
  if (!normalized) {
    return [];
  }

  const variants = new Set([
    normalized,
    expandGermanSearchCharacters(normalized),
    stripDiacritics(normalized),
    stripDiacritics(expandGermanSearchCharacters(normalized)),
  ]);

  return Array.from(variants).filter(Boolean);
}

function splitResponsibleName(fullName) {
  const normalized = String(fullName || '').trim();
  if (!normalized) {
    return { firstName: '', lastName: '', fullName: '' };
  }

  const commaSeparated = normalized.split(',').map((part) => part.trim()).filter(Boolean);
  if (commaSeparated.length >= 2) {
    return {
      lastName: commaSeparated[0],
      firstName: commaSeparated.slice(1).join(' '),
      fullName: normalized,
    };
  }

  const tokens = normalized.split(/\s+/).filter(Boolean);
  if (tokens.length >= 2) {
    return {
      firstName: tokens.slice(0, -1).join(' '),
      lastName: tokens[tokens.length - 1],
      fullName: normalized,
    };
  }

  return {
    firstName: normalized,
    lastName: normalized,
    fullName: normalized,
  };
}

function buildResponsibleCandidateSearchValues(candidate) {
  const fullName = candidate?.full_name || candidate?.fullName || '';
  const { firstName, lastName } = splitResponsibleName(fullName);

  const rawValues = [
    fullName,
    `${firstName} ${lastName}`.trim(),
    `${lastName} ${firstName}`.trim(),
    firstName,
    lastName,
  ].filter(Boolean);

  const values = new Set();
  rawValues.forEach((value) => {
    buildSearchVariants(value).forEach((variant) => values.add(variant));
  });

  return Array.from(values);
}

export function matchesResponsibleCandidate(candidate, query) {
  const needles = buildSearchVariants(query);
  if (needles.length === 0) {
    return true;
  }

  const haystacks = buildResponsibleCandidateSearchValues(candidate);
  return haystacks.some((haystack) => needles.some((needle) => haystack.includes(needle)));
}

export function filterResponsibleCandidates(candidates = [], query = '') {
  return candidates.filter((candidate) => matchesResponsibleCandidate(candidate, query));
}

export function getResponsibleCandidateLabel(candidate) {
  return candidate?.full_name || candidate?.fullName || '';
}